import React from "react";
import { FormattedMessage } from "react-intl";
import { ButtonContainer } from "./styles";
import BackIcon from "../../../../icons/Back";
import { FaRegTrashAlt as TrashIcon } from "react-icons/fa";

export default function Button({ theme, size, Icon, label, ...rest }) {
  const icons = new Map();
  icons.set("search", <SearchIcon />);
  icons.set("report", <Report />);
  icons.set("download", <Download />);
  icons.set("trash", <TrashIcon size={16} />);
  icons.set("back", <BackIcon size={16} />);

  const icon = icons.get(Icon);

  return (
    <ButtonContainer role="button" {...rest} theme={theme} size={size}>
      {icon}
      <FormattedMessage id={label} />
    </ButtonContainer>
  );
}

function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clip-path="url(#clip0_976_3544)">
        <path
          d="M7.00004 12.8067C10.1296 12.8067 12.6667 10.2696 12.6667 7.14002C12.6667 4.01043 10.1296 1.47336 7.00004 1.47336C3.87044 1.47336 1.33337 4.01043 1.33337 7.14002C1.33337 10.2696 3.87044 12.8067 7.00004 12.8067Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M8.88561 4.92105C8.40305 4.43848 7.73638 4.14001 6.99998 4.14001C6.26361 4.14001 5.59695 4.43848 5.11438 4.92105"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.0739 11.2139L13.9023 14.0424"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_976_3544">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.140015)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function Report() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      fill="none"
      viewBox="0 0 16 18"
    >
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <g
            stroke="#505052"
            strokeLinejoin="round"
            strokeWidth="1.143"
            clipPath="url(#c)"
          >
            <path
              strokeLinecap="round"
              d="M3.24 17.709a1.904 1.904 0 0 1-1.905-1.904V.57h8.57l4.76 4.76v10.474a1.904 1.904 0 0 1-1.905 1.904z"
            ></path>
            <path d="M8.952.571v5.713h5.713"></path>
            <path
              strokeLinecap="round"
              d="M5.144 10.092h5.712M5.144 13.9h5.712"
            ></path>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h16v18H0z"></path>
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M0 0h16v18.28H0z"></path>
        </clipPath>
        <clipPath id="c">
          <path fill="#fff" d="M.002 0h15.995v18.28H.002z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

const Download = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <path
      stroke="#024"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2 8.503V14.5h12v-6"
    ></path>
    <path
      stroke="#024"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m11 8.167-3 3-3-3M7.997 2.5v8.667"
    ></path>
  </svg>
);
